(function() {
    'use strict';

    angular
        .module('bhsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('param-formulaire', {
            parent: 'entity',
            url: '/param-formulaire',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'bhsApp.paramFormulaire.home.title'
            },
            views: {
                'content@bhs': {
                    templateUrl: 'app/entities/param-formulaire/param-formulaires.html',
                    controller: 'ParamFormulaireController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('paramFormulaire');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
